<template>
  <div class="modal fade" id="customSyncMonitor" tabindex="-1" role="dialog" aria-labelledby="customSyncMonitor" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Bulk Update Zabbix Settings</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="loader" v-if="loading"></div>
          <template v-else-if="!loading & stepper === 1">
            <div  class="row pl-15 pr-15 mt-10">
              <div class="col-md-6 form-check-radio">
                <label class="form-check-label">
                  <input class="form-check-input" v-model="selectedValue" type="radio" name="checkAllDomains" id="inputDomain" value="checkAll"> Select all domains
                  <span class="form-check-sign"></span>
                </label>
              </div>
              <div class="col-md-6 form-check-radio">
                <label class="form-check-label">
                  <input class="form-check-input" v-model="selectedValue" type="radio" name="uncheckAllDomains" id="status" value="uncheckAll"> Uncheck all domains
                  <span class="form-check-sign"></span>
                </label>
              </div>
            </div>
            <div class="row mt-5">
              <perfect-scrollbar class="scroll-area col-md-12">
                <table class="table single-outage-table">
                  <thead>
                  <tr>
                    <th><b>Domain Name</b></th>
                    <th class="text-center">Action</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(row, index) in allAccounts" :key="index">
                    <td>{{ row.domain }}</td>
                    <td>
                      <div class="custom-control custom-checkbox mr-sm-2 d-flex justify-content-center">
                        <input type="checkbox" class="custom-control-input" name="identifiers" v-model="checkAll" :value="row" :id="index"/>
                        <label class="custom-control-label" :for="index"></label>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </perfect-scrollbar>
            </div>
            <hr class="mt-20 mb-20">
            <div class="mt-5">
              <label class="fw-600">Select Action</label>
              <select class="form-control" v-model="selectedActionType">
                <option v-for="action in actionOptions" :value="action" :key="action.text">
                  {{action.text}}
                </option>
              </select>
            </div>
            <div class="mt-5">
              <button  class="btn btn-success pull-right" :disabled="!(selectedActionType && checkAll.length)" @click.prevent="stepper++">
                <span >Next</span>
              </button>
            </div>
          </template>
          <template v-else>
            <div  class="row pl-15 pr-15 mt-10">
              <div class="col-md-12">
                <div class="fw-500 fs-16 text-primary">Are you sure you want to update Zabbix details with the following section?</div>
                <br>
                <div class="mr-10 fw-600">Selected Action</div>
                <input class="form-control" :value="selectedActionType.text" :disabled="true" />
              </div>
            </div>
            <div class="row mt-10">
              <div class="col-md-12">
                <perfect-scrollbar class="scroll-area col-md-12">
                  <table class="table single-outage-table">
                    <thead>
                    <tr>
                      <th><b>Domain Name</b></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(row, index) in checkAll" :key="index">
                      <td>{{ row.domain }}</td>
                    </tr>
                    </tbody>
                  </table>
                </perfect-scrollbar>
              </div>
            </div>
            <hr class="mt-20 mb-20">
            <div class="mt-5">
              <button class="btn btn-success pull-right" :disabled="loading" @click.prevent="submit()">
                <span>Update Zabbix Monitor Details to WPO</span>
              </button>
              <button  class="btn btn-danger pull-right" :disabled="loading" @click.prevent="stepper--">
                <span>Back</span>
              </button>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {PerfectScrollbar} from 'vue2-perfect-scrollbar';
import swal from "sweetalert2";
export default {
  name: "customSyncBetterUpTimeModal",
  components: {
    PerfectScrollbar
  },
  data () {
    return {
      stepper: 1,
      selectedPlanIndex: null,
      checkAll: [],
      selectedValue: '',
      usingWithOutUsingFlag : 'using',
      loading: false,
      selectedFilteredCloudFareAccount: null,
      selectedActionType: {
        text: '',
        action: '',
      },
      actionOptions: [
        {text: 'Create', action: 'add'},
        {text: 'Delete', action: 'delete'}
      ],
      serverIP: null,
    }
  },
  watch: {
    selectedValue (val) {
      if (val === 'checkAll') {
        this.checkAll=[]
        for (const row of this.allAccounts) {
          this.checkAll.push(row)
        }
        this.selectedFilteredCloudFareAccount= null;
        this.usingWithOutUsingFlag = 'using'
      } else if (val === 'uncheckAll') {
        this.checkAll = [];
        this.selectedFilteredCloudFareAccount= null;
        this.usingWithOutUsingFlag = 'using'
      }
    },
  },
  computed: {
    custID() {
      return this.$store.getters["customer/id"];
    },
    customerInfo () {
      return this.$store.getters["customer/details"];
    },
    docID() {
      return this.$store.getters["customer/docID"];
    },
    hostingAccounts() {
      return this.$store.getters["hosting/accountsOrdered"];
    },
    allAccounts() {
      let hostingAccounts = this.$store.getters["hosting/accountsOrdered"];
      hostingAccounts = hostingAccounts.filter(acc => {
        if (!acc.deleted) {
          return acc;
        }
        return false;
      });
      hostingAccounts = hostingAccounts.filter(el => el.planIndex === this.selectedPlanIndex)
      return hostingAccounts
    },
  },
  methods: {
    load(account) {
      console.log('account',account)
      this.stepper = 1
      this.selectedValue = 'checkAll'
      this.selectedActionType= null
      this.serverIP= account.serverIP
      this.selectedPlanIndex = account.planIndex
      console.log('all accounts', this.selectedPlanIndex, this.allAccounts)
      $('#customSyncMonitor').modal('show');
    },
    async submit(){
      try {
        if (!this.checkAll.length) {
          return;
        }
        this.loading = true
        const selectedDomains = [];

        this.checkAll.forEach((value)=>{
          selectedDomains.push(value.domain)
        })
        console.log(this.checkAll, 'Selected Domains before')
        console.log(this.custID, 'Selected Customer ID')

        const {firstName , lastName , docID: UID} = this.customerInfo;
        await this.$http.post("monitor/custom-sync", {
          customerId: UID,
          grant_type: "token",
          firstName ,
          lastName,
          ip: this.serverIP,
          hostingAccountId: this.docID,
          selectedDomains: this.checkAll,
          type: 'fetch-domains',
          actionType: this.selectedActionType.action
        });

        this.loading = false
        $("#customSyncMonitor").modal('hide');
        await swal('Success', 'You have successfully updated Zabbix Monitor details to WPO', 'success')
      }
      catch(e){
        this.loading = false
        console.log(e.toString(), 'Error Occurred while updating Zabbix Monitor details')
        $("#customSyncMonitor").modal('hide');
        await swal('Error', 'Something went wrong updating Zabbix Monitor details', 'error')
      }
    },
  }
}
</script>

<style scoped>

</style>
